import { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import { cn } from '../../lib/utils';
import { resolveImage } from '../../lib/images';

/** Product photo on white, object-contain; placeholder when missing / broken. */
export default function ItemImage({ src, alt = '', className, imgClassName, iconClassName, rounded = 'rounded-lg' }) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  const show = src && !failed;
  return (
    <div className={cn('relative flex items-center justify-center overflow-hidden bg-white', rounded, className)}>
      {show ? (
        // layered inside the box (inheriting its padding) so a tall or wide photo
        // can never stretch the box: the box keeps its size, the photo scales down
        <span className="absolute inset-0 flex items-center justify-center [padding:inherit]">
          <img
            src={resolveImage(src)}
            alt={alt}
            loading="lazy"
            onError={() => setFailed(true)}
            className={cn('h-full w-full object-contain', imgClassName)}
          />
        </span>
      ) : (
        <ImageOff className={cn('h-8 w-8 text-slate-300', iconClassName)} strokeWidth={1.25} />
      )}
    </div>
  );
}
